export default __webpack_public_path__ + "static/qamialayer-tunnel-1cb4cd42ee26a6cd7ffb4fffa63bc5d1.png";